import httpClient from '@/api/httpClient'
import { defineStore } from 'pinia'
import { useMessagesStore } from '@/stores/messages'

export const useRolesStore = defineStore('roles', {
  state: () => ({
    roles: [],
    fetchInitiated: false
  }),

  actions: {
    async fetch() {
      this.fetchInitiated = true

      return httpClient.get('/api/internal/roles')
        .then(response => {
          this.roles = response.data.roles
        })
        .catch((err) => {
          useMessagesStore().smartAdd(err)
        })
    },

    async fetchOnce() {
      if (this.fetchInitiated) return Promise.resolve()

      return this.fetch()
    }
  }
})
